/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Ikke selg eller del min personlige informasjon",
      "Bumble Date",
      "Våre apper",
      "Om",
      "Karriere",
      "Kontakt oss",
      "Investorer",
      "The Shop",
      "Firma",
      "Last ned appen",
      "Tilrettelegging på Bumble",
      "Retningslinjer",
      "Administrer cookies",
      "Modern Slavery act",
      "Lagring av data",
      "Personvernserklæring",
      "Vilkår og betingelser",
      "Vilkår",
      "Washington Consumer Health Privacy Policy",
      "Scan QR-koden for å få Bumble-appen",
      "Avslutt kontrakter her",
      "Lukk meny",
      "Åpne meny",
      "Språkvalg",
      "Footer",
      "Tilrettelegging på Bumble",
      "Apple og Apple-logoen er varemerker fra Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Jobbmuligheter",
      "Google Play er et varemerke som eies av Google LLC.",
      "Retningslinjer",
      "Investorer",
      "Administrer cookies",
      "Modern Slavery Act Statement",
      "Lagring av data",
      "Personvern",
      "Sesongbestemte dating-guider",
      "Vilkår & Betingelser",
      "Appen",
      "Personvernsreglement for Consumer Health Data i Washington",
      "Om",
      "Ambassadører",
      "Få nye venner og finn tilhørighet",
      "Bygg nettverk på profesjonelt vis og gjør karrieretrekk",
      "Finn et forhold, noe mindre seriøst eller noe midt imellom",
      "The Buzz",
      "Finn ut mer",
      "Gå globalt med Reisemodus",
      "Date",
      "Funksjoner",
      "Compliments",
      "Send Compliments for å skille deg ut i mengden.",
      "Oppdag",
      "En personlig side som fremhever de mest kompatible personene dine, oppdatert daglig.",
      "Usynlighet",
      "Bruk Usynlighet hvis du vil skjule profilen din for noen – for eksempel eksen eller sjefen.",
      "Umiddelbar match",
      "Begynte samtalen på et Bumble-event? Fortsett på appen.",
      "Opening Moves",
      "Prøv Opening Moves< for å få chatten i gang på en kul måte.",
      "Slumre-modus",
      "Ta en pause med Slumre-modus. Du vet hvor vi er når du er klar for dating igjen.",
      "Superswipe",
      "Imponert av profilen deres? La dem få vite det med en SuperSwipe.",
      "Reisemodus",
      "Finn matcher hvor som helst i verden med Reisemodus.",
      "Videochat",
      "Bruk videochat eller lydsamtale for å sjekke om du er klar til å møtes på ordentlig.",
      "Web-app",
      "Få Bumble-opplevelsen direkte fra nettleseren din.",
      "Få Bumble-appen",
      "BFF",
      "Sikkerhet",
      "Historier",
      "Kundeservice",
      "The Shop",
      "Hoved",
      "Send komplimenter for å skille deg ut i mengden.",
      "Compliments",
      "Funksjoner designet for å skape rom for ekte, respektfulle og meningsfulle forbindelser.",
      "Skjul profilen din hvis du vil – for eksempel fra eksen eller sjefen",
      "Usynlighet",
      "Ta en pause med Slumre-modus",
      "Slumre-modus",
      "Sett noen du liker? La dem få vite det",
      "Superswipe",
      "Utforsk Date",
      "Finn matcher hvor som helst i verden",
      "Reisemodus",
      "Som å nesten møte hverandre, uten å dra hjemmefra",
      "Videoanrop",
      "Våre ambassadører hjelper med å bringe Bumble sine verdier inn i fellesskap over hele landet.",
      "Ambassadører",
      "Funksjoner designet for å hjelpe deg med å finne dine folk og bli kjent over felles interesser",
      "Organiser et gruppemøte, eller oppdag lokale eventer som skjer i nærheten.",
      "Plans",
      "Utforsk BFF",
      "Alle tips og inspirasjon du trenger på veien til å finne kjærlighet og vennskap.",
      "Råd og historier for å hjelpe deg med å bygge meningsfulle vennskap.",
      "Hub for vennskap",
      "Fra Tokyo til Toronto, bli kjent med kjærlighetshistorier fra Bumble.",
      "Kjærlighetshistorier",
      "Planlegg den perfekte daten – uansett hvor, når eller hvem det er.",
      "Datingtips for årstidene",
      "Utforsk historier",
      "Les mer",
      "Bumble på {{social_network}}",
      "Kontakt oss",
      "Logg inn",
      "(opens in new window)",
      "Ofte stilte spørsmål",
      "Cookie Policy",
      "Bumble - The Blog",
      "Jobbmuligheter",
      "Chat",
      "Byer",
      "Administrer cookies",
      "Copyright © 2006 – nå. Bumble. Alle rettigheter forbeholdes.",
      "Datingrapport",
      "Apple og Apple-logoen er varemerker for Apple Inc.{{__EOL__}}Google Play er et varemerke som eies av Google LLC.",
      "Last ned",
      "Facebook",
      "Følg oss",
      "Hjelpesenter",
      "Instagram",
      "Språk",
      "LinkedIn",
      "Bumble er en del av Bumble Inc.",
      "Personvernerklæring",
      "Safety Centre",
      "Sidekart",
      "Modern Slavery Act statement",
      "Vilkår og betingelser",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dager"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "timer"
            ],
            "singular": [
                  "time"
            ]
      },
      "minute": {
            "plural": [
                  "minutter"
            ],
            "singular": [
                  "minutt"
            ]
      },
      "month": {
            "plural": [
                  "måneder"
            ],
            "singular": [
                  "måned"
            ]
      },
      "second": {
            "plural": [
                  "sekunder"
            ],
            "singular": [
                  "sekund"
            ]
      },
      "year": {
            "plural": [
                  "år"
            ],
            "singular": [
                  "år"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
